var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Observable_instances, _Observable_call, _ObservableLog_instances, _ObservableLog_call;
export class Observable extends Function {
    constructor() {
        super();
        _Observable_instances.add(this);
        this.observers = [];
        return new Proxy(this, {
            apply: (target, _, args) => __classPrivateFieldGet(target, _Observable_instances, "m", _Observable_call).call(target, args[0]),
        });
    }
    subscribe(func) {
        this.observers.push(func);
    }
    unsubscribe(func) {
        this.observers = this.observers.filter(observer => observer !== func);
    }
    notify(data) {
        this.observers.forEach(observer => observer(data));
    }
}
_Observable_instances = new WeakSet(), _Observable_call = function _Observable_call(message) {
    this.notify(message);
};
export class ObservableLog extends Observable {
    constructor() {
        super();
        _ObservableLog_instances.add(this);
        return new Proxy(this, {
            apply: (target, _, args) => __classPrivateFieldGet(target, _ObservableLog_instances, "m", _ObservableLog_call).call(target, args[0]),
        });
    }
    log(message) {
        this.notify({ message, level: 'info' });
    }
    warn(message) {
        this.notify({ message, level: 'warn' });
    }
    error(message, error) {
        this.notify({ message, level: 'error', error });
    }
}
_ObservableLog_instances = new WeakSet(), _ObservableLog_call = function _ObservableLog_call(message) {
    this.log(message);
};
//# sourceMappingURL=observable.js.map